import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material';

// ID de la vidéo à afficher – à mettre à jour si besoin
const FEATURED_VIDEO_ID = 'obP42qi0s54';

function FeaturedVideo({ videoId }) {
  const theme = useTheme();
  const containerRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!videoId || !containerRef.current) return;

    const initPlayer = () => {
      if (!window.YT || !window.YT.Player) return;
      if (playerRef.current && typeof playerRef.current.destroy === 'function') {
        try {
          playerRef.current.destroy();
        } catch (_) {}
        playerRef.current = null;
      }
      const el = containerRef.current;
      if (!el) return;
      playerRef.current = new window.YT.Player(el, {
        videoId,
        width: '100%',
        height: '100%',
        playerVars: {
          rel: 0,
          enablejsapi: 1,
          origin: window.location.origin,
        },
        events: {},
      });
    };

    if (window.YT && window.YT.Player) {
      initPlayer();
    } else {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (prev) prev();
        initPlayer();
      };
      if (!document.getElementById('youtube-iframe-api')) {
        const tag = document.createElement('script');
        tag.id = 'youtube-iframe-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    }

    return () => {
      if (playerRef.current && typeof playerRef.current.destroy === 'function') {
        try {
          playerRef.current.destroy();
        } catch (_) {}
        playerRef.current = null;
      }
    };
  }, [videoId]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%',
        borderRadius: 3,
        overflow: 'hidden',
        bgcolor: 'rgba(26, 43, 72, 0.04)',
        backgroundImage:
          'linear-gradient(135deg, rgba(212,175,55,0.18) 0%, rgba(26,43,72,0.03) 55%, rgba(178,34,34,0.08) 100%)',
        border: '1px solid rgba(26, 43, 72, 0.14)',
        boxShadow: theme.shadows[2],
      }}
    >
      <Box
        ref={containerRef}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </Box>
  );
}

export function YouTubeCarousel({ videoId = FEATURED_VIDEO_ID }) {
  return (
    <Box>
      <FeaturedVideo videoId={videoId} />
    </Box>
  );
}

export default YouTubeCarousel;
